import React from "react";
import { FormattedMessage } from "react-intl";
import { Row, Space } from "@masterteam/mt-design-react";

import AsyncSvg from "../../AsyncSvg";

import { useIsAr } from "../../../Hooks";

import icon from "../../../assets/images/level-one.svg";
import { ReactComponent as LevelTwoIcon } from "../../../assets/images/level-two.svg";
import { ReactComponent as LevelOneIcon } from "../../../assets/images/level-one.svg";
import { ReactComponent as SupportiveIcon } from "../../../assets/images/supportive-objective.svg";

import "./style.scss";

const ObjectiveTitle = ({ objective, parentKey, statuses }) => {
  const [isAr] = useIsAr();

  const status = statuses?.find((e) => e.Code === objective.Status);

  return (
    <Row justify="between" className="objective-title" align="stretch">
      <Space align="center" className="title-wrapper">
        {+objective?.StrategyType === 2 ? (
          <SupportiveIcon
            className="icon"
            fill={objective?.[parentKey].Color}
          />
        ) : +objective?.Level === 1 ? (
          <LevelOneIcon className="icon" fill={objective?.[parentKey].Color} />
        ) : (
          <LevelTwoIcon className="icon" fill={objective?.[parentKey].Color} />
        )}
        <div>{isAr ? objective?.ArabicName : objective?.EnglishName}</div>
      </Space>

      {+objective?.StrategyType === 2 ? (
        <div className="performance" style={{ backgroundColor: status.Color }}>
          {objective.Performance} %
        </div>
      ) : (
        <Space align="center" size="large" className="theme-wrapper">
          <div className="gray-line" />

          <Space align="center" size="medium">
            <FormattedMessage
              id={
                +objective?.StrategyType === 1
                  ? "common.theme"
                  : "common.pillar"
              }
            />
            :
            <Space align="center">
              <AsyncSvg
                defaultSvg={icon}
                className="icon"
                color={objective?.[parentKey].Color}
                attachment={objective?.[parentKey].Attachment}
              />
              <div>
                {isAr
                  ? objective?.[parentKey].ArabicName
                  : objective?.[parentKey].EnglishName}
              </div>
            </Space>
          </Space>

          <div className="gray-line" />

          <Space align="center" size="medium">
            <FormattedMessage id="common.perspective" />:
            <Space align="center">
              <AsyncSvg
                defaultSvg={icon}
                className="icon"
                color="var(--primary-color)"
                attachment={objective?.Perspective.Attachment}
              />
              <div>
                {isAr
                  ? objective?.Perspective.ArabicName
                  : objective?.Perspective.EnglishName}
              </div>
            </Space>
          </Space>
        </Space>
      )}
    </Row>
  );
};

export default ObjectiveTitle;
